export const NFE_DIVERSOS_LIST_URL =
  'http://www.nfe.fazenda.gov.br/portal/listaConteudo.aspx?tipoConteudo=/NJarYc9nus=';

/** NF-e NT 2018.003 v1.01 country table (ODS) — discovered from Documentos → Diversos. */
export const NFE_PAISES_TABLE_URL =
  'http://www.nfe.fazenda.gov.br/portal/exibirArquivo.aspx?conteudo=PfPDd6dW200=';

export const BACEN_PAISES_FTP_URL = 'https://www.bcb.gov.br/ftp/paises.txt';

export const PAISES_BACEN_GOLDEN_BRASIL = '1058';

export const PAISES_BACEN_MIN_PAISES = 240;
export const PAISES_BACEN_MAX_PAISES = 270;
